// SuperKonnected Theme Tokens - SuperChat AI Style  
// Consistent styling across all tabs

// SuperChat AI Header - Clean white
export const headerGrad = "bg-white";
export const headerShell = headerGrad + " text-ink-900";
export const headerHeight = "h-24"; // 96px
export const headerPad = "px-6";

// Layout containers
export const container = "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8";
export const containerClass = "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8"; // Alias for compatibility
export const card = "rounded-2xl border border-gray-200/60 bg-white shadow-sm";
export const cardClass = "rounded-2xl border border-gray-200/60 bg-white shadow-sm"; // Alias for compatibility

// Header styling
export const headerClass = headerShell; // Alias for compatibility

// Section styling
export const sectionPad = "p-6"; // Standard section padding

// SubNav chip styling
export const subnavActive = headerGrad + " text-ink-900 shadow-sm";
export const subnavIdle = "bg-white text-gray-700 border border-gray-200 hover:bg-gray-50";
export const focusRing = "focus:outline-none focus-visible:ring-2 focus-visible:ring-[#7A6FF6]";

// Tab styling aliases for compatibility
export const tabActiveClass = subnavActive;
export const tabInactiveClass = subnavIdle;
export const motionSafeClass = "motion-safe:transition-colors motion-safe:duration-200";

// Spacing and layout
export const tabSpacing = "gap-2";
export const tabHeight = "h-9";
export const tabPadding = "px-4";
export const tabRadius = "rounded-xl";

// Typography
export const headerTitle = "text-2xl font-semibold";
export const headerSubtitle = "text-sm opacity-90";
export const tabText = "text-sm font-medium";

// States and interactions
export const hoverTransition = "transition-all duration-200";
export const activeState = "aria-current";